import { LoadingIndicator } from 'ionic-ui';

export default function LoaderAnimation() {
  return <LoadingIndicator />;
}
